<script setup>
// import { UserIcon, UsersIcon } from "@heroicons/vue/16/solid";
import EmptyCardComponent from "@/components/cards/EmptyCardComponent.vue";
import TextInputComponent from "@/components/form/TextInputComponent.vue";
import BasicButtonComponent from "@/components/form/BasicButtonComponent.vue";
import {computed, ref} from "vue";
import { useAuthStore } from "@/stores/auth";

const form = ref({
  email: '',
  password: '',
  remember: false
}),
 store = useAuthStore(),
 error = computed(() => store.error),
 login = (form) => {
  store.attemptLogin(form)
 };
</script>

<template>
  <empty-card-component
    class="p-4 rounded-xl"
    style="backdrop-filter: blur(50px); background-color: #fff9"
  >
    <template #body>
      <div class="">
        <form
          class="mb-4"
          @submit.prevent="login(form)"
        >
          <text-input-component
            id="email"
            v-model:input-value="form.email"
            :type="`email`"
            name="email"
            placeholder="Email"
            required
            class="py-3 mb-4 placeholder:text-base placeholder-gray-400"
          />
          <text-input-component
            id="password"
            v-model:input-value="form.password"
            :type="`password`"
            name="password"
            placeholder="Password"
            required
            class="py-3 mb-4 placeholder:text-base placeholder-gray-400"
          />
          <label
            for="remember-me"
            class="text-base flex items-center"
          >
            <input
              id="remember-me"
              v-model="form.remember"
              type="checkbox"
              name="remember-me"
              class="mr-2"
            >
            Remember me
          </label>
          <span
            v-if="error && error !== 'Unauthenticated.'"
            class="text-xs text-red-500"
          >{{ error }}</span>
          <basic-button-component
            type="submit"
            class="mt-4 w-full text-lg text-white font-semibold py-3 block ml-auto bg-green-700"
          >
            Log in
          </basic-button-component>
        </form>
        <div class="flex items-center justify-between mb-4">
          <router-link
            to="/reset-password"
            class="text-base text-teal-600"
          >
            Forgot password
          </router-link>
          <router-link
            to="/register"
            class="text-base text-teal-600"
          >
            <span class="text-red-600">Not account?</span>
            Register
          </router-link>
        </div>
        <!--        <span>-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</span> or <span>-&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;&#45;</span>-->
        <!--        <div class="flex flex-1 space-x-5 items-center justify-center mt-4">-->
        <!--          <a-->
        <!--            href=""-->
        <!--            target="_blank"-->
        <!--            class="border-2 border-green-700 bg-teal-700 text-white rounded-full"-->
        <!--          >-->
        <!--            <user-icon class="h-6 w-6" />-->
        <!--          </a>-->
        <!--          <a-->
        <!--            href=""-->
        <!--            target="_blank"-->
        <!--            class="border-2 border-green-700 bg-teal-700 text-white rounded-full"-->
        <!--          >-->
        <!--            <users-icon class="h-6 w-6" />-->
        <!--          </a>-->
        <!--        </div>-->
      </div>
    </template>
  </empty-card-component>
</template>

<style scoped></style>
